import { useParams } from "react-router-dom";

import { DebitNegotiationDashboard } from "../dashboard/ModalDebits";
import { ToastProvider } from "@/common/components/ui/toast/toast.provider";
import Dashboard from "@/common/components/layout/Dashboard";
import Toast from "@/common/components/ui/toast";

function NegotiationDebitsDetails() {
  const { renterId } = useParams()

  return (
    <ToastProvider>
      <Dashboard>
        {renterId && (
          <DebitNegotiationDashboard renterId={renterId} />
        )}
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default NegotiationDebitsDetails